import { TranslationsContext } from '@teliaee/telia-translate';
import * as frontComponents from 'telia-front-react';
import { Container, Notice, Separator } from 'telia-front-react';
import React from 'react';
import ServiceNumbers from '../billing/ServiceNumbers';
import ChoosePackets from '../cms/ChoosePackets';
import ProductCarousel from '../cms/ProductCarousel';
import ProductOverview from '../cms/ProductOverview';
import config from '../config';
import GravityForm from '../forms/GravityForm';
import SmsLink from '../roaming/packages/SmsLink';
import Roaming from '../roaming/Roaming';
import RoamingNumberResults from '../roaming/RoamingNumberResults';
import RoamingNumberSearch from '../roaming/RoamingNumberSearch';
import LoggedIn from '../sso/LoggedIn';
import LoggedOut from '../sso/LoggedOut';
import LoginAnchor from '../sso/LoginAnchor';
import LoginButton from '../sso/LoginButton';
import ErrorUtil from '../util/ErrorUtil';
import GaPush from '../wrapper/GaPush';
import ExtendedJsxParser from './ExtendedJsxParser';
import News from './common/NewsContainer';
import StoresOpeningInformation from '../contacts/StoresOpeningInformation';

interface JsxRendererProps {
  jsx: string;
  onError?: () => void;
  showErrorNotice?: boolean;
}

interface JsxRendererState {
  errored: boolean;
}

class JsxRenderer extends React.Component<JsxRendererProps, JsxRendererState> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public constructor(props: JsxRendererProps) {
    super(props);
    this.state = { errored: false };
  }

  componentDidUpdate = (prevProps: Readonly<JsxRendererProps>) => {
    if (this.props.jsx !== prevProps.jsx && this.state.errored) {
      this.setState({ errored: false });
    }
  };

  public shouldComponentUpdate(nextProps: JsxRendererProps, nextState: JsxRendererState): boolean {
    return nextProps.jsx !== this.props.jsx || this.state.errored !== nextState.errored;
  }

  public componentDidMount() {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }

  private renderError = () => {
    const translate = this.context.translate;
    return (
      <Container>
        <Separator spacing="large" color="invisible" />
        <div role="alert">
          <Notice type="error">{translate('general.error.message')}</Notice>
        </div>
        <Separator spacing="large" color="invisible" />
      </Container>
    );
  };

  private handleError = (e: Error) => {
    this.setState({ errored: true });
    const jsxError = new Error(`JSX render failed on ${window.location.pathname}`);
    jsxError.stack = e.stack;
    ErrorUtil.pushErrorToTeliaRumAndLog(jsxError);
  };

  public render() {
    if (this.state.errored && this.props.showErrorNotice) {
      return this.renderError();
    }

    return (
      // @ts-ignore
      <ExtendedJsxParser
        components={{
          ...frontComponents,
          LoggedIn,
          LoggedOut,
          LoginAnchor,
          LoginButton,
          Roaming,
          News,
          GravityForm,
          ChoosePackets,
          ProductCarousel,
          ProductOverview,
          ServiceNumbers,
          SmsLink,
          GaPush,
          RoamingNumberSearch,
          RoamingNumberResults,
          StoresOpeningInformation
        }}
        onError={this.handleError}
        showWarnings={config.environment !== 'live'}
        {...this.props}
        jsx={this.props.jsx}
      />
    );
  }
}

export default JsxRenderer;
